import Select from "react-select";
const layerNames = [
  { label: "default (legacy)", value: "default" },
  { label: "full (legacy)", value: "full" },
  { label: "acronym (legacy)", value: "acronym" },
  { label: "colloquial (legacy)", value: "colloquial" },
  { label: "name (legacy)", value: "name" },
  { label: "number (legacy)", value: "number" },
  { label: "DEFAULT", value: "DEFAULT" },
  { label: "FULLNAME", value: "FULLNAME" },
  { label: "ACRONYM", value: "ACRONYM" },
  { label: "COLLOQUIAL", value: "COLLOQUIAL" },
  { label: "COLLOQUIALLETTERS", value: "COLLOQUIALLETTERS" },
  { label: "COLLOQUIALNAME", value: "COLLOQUIALNAME" },
  { label: "COLLOQUIALPHRASE", value: "COLLOQUIALPHRASE" },
  { label: "CITY", value: "CITY" },
  { label: "CITY", value: "CITY" },
  { label: "FOUNDINGYEAR", value: "FOUNDINGYEAR" },
  {
    label: "FOUNDINGCENTURY",
    value: "FOUNDINGCENTURY",
  },
  {
    label: "FOUNDINGDECADE",
    value: "FOUNDINGDECADE",
  },
  { label: "MOTTO", value: "MOTTO" },
  { label: "MOTTOSHORT", value: "MOTTOSHORT" },
  { label: "MOTTOLONG", value: "MOTTOLONG" },
  { label: "SPORT_FIXEDH", value: "SPORT_FIXEDH" },
  {
    label: "FULLNAME_FIXEDH",
    value: "FULLNAME_FIXEDH",
  },
  {
    label: "ACRONYM_FIXEDH",
    value: "ACRONYM_FIXEDH",
  },
  {
    label: "COLLOQUIALLETTERS_FIXEDH",
    value: "COLLOQUIALLETTERS_FIXEDH",
  },
  {
    label: "COLLOQUIALNAME_FIXEDH",
    value: "COLLOQUIALNAME_FIXEDH",
  },
  {
    label: "COLLOQUIALPHRASE_FIXEDH",
    value: "COLLOQUIALPHRASE_FIXEDH",
  },
  { label: "CITY_FIXEDH", value: "CITY_FIXEDH" },
  { label: "STATE_FIXEDH", value: "STATE_FIXEDH" },
  {
    label: "FOUNDINGYEAR_FIXEDH",
    value: "FOUNDINGYEAR_FIXEDH",
  },
  {
    label: "FOUNDINGDECADE_FIXEDH",
    value: "FOUNDINGDECADE_FIXEDH",
  },
  {
    label: "FOUNDINGCENTURY_FIXEDH",
    value: "FOUNDINGCENTURY_FIXEDH",
  },
  { label: "MOTTO_FIXEDH", value: "MOTTO_FIXEDH" },
  {
    label: "MOTTOSHORT_FIXEDH",
    value: "MOTTOSHORT_FIXEDH",
  },
  {
    label: "MOTTOLONG_FIXEDH",
    value: "MOTTOLONG_FIXEDH",
  },
  {
    label: "DEFAULT_FIXEDH",
    value: "DEFAULT_FIXEDH",
  },
  { label: "FIRSTNAME", value: "FIRSTNAME" },
  { label: "LASTNAME", value: "LASTNAME" },
  { label: "NUMBER", value: "NUMBER" },
  { label: "HOMETOWN", value: "HOMETOWN" },
  {
    label: "FIRSTNAME_FIXEDH",
    value: "FIRSTNAME_FIXEDH",
  },
  {
    label: "LASTNAME_FIXEDH",
    value: "LASTNAME_FIXEDH",
  },
  {
    label: "NUMBER_FIXEDH",
    value: "NUMBER_FIXEDH",
  },
  {
    label: "HOMETOWN_FIXEDH",
    value: "HOMETOWN_FIXEDH",
  },
  { label: "SPORT", value: "SPORT" },
];

export function DesignLayerSelector({
  configurationLayers,
  setConfigurationLayers,
}: {
  configurationLayers: { label: string; value: string }[];
  setConfigurationLayers: (val: any) => void;
}) {
  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <div className="flex-1 min-w-0 mt-4">Design Layer Selections</div>
      </div>
      <div className="mt-1 space-y-8">
        <Select
          isSearchable
          isMulti
          name="design_layers"
          options={layerNames}
          value={configurationLayers}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={(e) => setConfigurationLayers(e)}
        />
      </div>
    </div>
  );
}
